import { Button, Icons } from '@commenda/kakashi';

interface CancellationSuccessStepProps {
  onClose?: () => void;
  name: string;
  expiryDate: string;
  type?: 'plan' | 'subscription';
}

export const CancellationSuccessStep = ({
  onClose,
  name,
  expiryDate,
  type = 'plan',
}: CancellationSuccessStepProps) => {
  const benefitsText =
    type === 'subscription' ? 'subscription benefits' : 'benefits';

  return (
    <div className="w-[500px] max-w-[500px] rounded-lg shadow-3xl p-6">
      <div className="flex items-start justify-between mb-4">
        <div className="flex items-center gap-3">
          <div className="w-12 h-12 rounded-lg bg-bg-success flex items-center justify-center flex-shrink-0">
            <Icons.CheckCircle className="w-6 h-6 text-text-success" />
          </div>
          <h2 className="txt-large-bold text-text-primary mr-8">
            {name} Cancelled Successfully
          </h2>
        </div>
      </div>

      <div className="mb-6">
        <p className="txt-small-regular text-text-secondary">
          Your current subscription will remain active until{' '}
          <span className="txt-small-medium text-text-primary">
            {expiryDate}
          </span>
          . After that, you won't be able to access the {benefitsText}. You can
          re-subscribe anytime from your dashboard.
        </p>
      </div>

      <div className="flex justify-end">
        <Button variant="primary" size="md" onClick={onClose}>
          Close
        </Button>
      </div>
    </div>
  );
};

export default CancellationSuccessStep;
